import React, {Component, Fragment} from 'react';
import {inject, observer} from 'mobx-react';
import {FormattedMessage, injectIntl} from 'react-intl';
import FormInput from '../../../components/FormHelpers/formField';
import MobileFormSelectField from '../../../components/FormHelpers/mobileFormSelectField';
import CircularLoaderInline from '../../../components/circularLoader/CircularLoaderInline';
import BaseButton from '../../../components/button/BaseButton';
import UploadTrackFileSelect from "./UploadTrackFileSelect";

@injectIntl
@inject('uploadTrackStore')
@observer
class UploadFormMobile extends Component {
    render() {
        const {header, form, fields, handleTrackName,
            signatures, submit, isUploading, onBlur, showAdvanced, toggleAdvanced,
            keys, onChangeKey, scales, onChangeScale, signature, onChangeSignature,
            handleBlur, handleInputChange, filterCharacters, toggleBpm,
            activeInstrument, onSelectInstrument, instruments, showFileUpload, handleClearFileInput,
            onFileChange, onFileError, previewError, validated,uploadTrackStore,
            intl: {formatMessage: translate}} = this.props;

        const isDisabledSubmit = !uploadTrackStore.isFormReady;

        return (
            <Fragment>
                <div className="modal-page-name"><FormattedMessage id="upload.form.addLoop" /></div>
                <div className="form-group">
                    <h3 className="upload-track-heading"><FormattedMessage id={header}/></h3>
                    {showFileUpload &&
                    <UploadTrackFileSelect
                        fileName={fields.file.value} onClear={handleClearFileInput}
                        onChange={onFileChange}
                        onError={onFileError}
                        previewError={previewError}
                        isValidated={validated}
                    />
                    }
                    <FormInput
                        id="upload-track-name-input" type="text" name="trackName"
                        inputPlaceholder={translate({id: 'looper.nameForm.newLessonPlaceholder'})}
                        placeholder={translate({id: 'upload.form.title'})} className="form-upload-title"
                        onChange={handleTrackName} onBlur={onBlur} value={fields.trackName.value}
                        error={fields.trackName.error && <FormattedMessage id="upload.form.error.titleEmpty"/>}/>
                    <div className="a-form-row">
                        <div className="a-form-col" onBlur={handleBlur}>
                            <FormInput
                                type="text" name="bpm" placeholder={<FormattedMessage id={showFileUpload ? 'upload.form.fileBpm' : 'studio.bpm'}/>}
                                onChange={handleInputChange} onBlur={onBlur}
                                filterCharacters={filterCharacters} value={fields.bpm.value} error={fields.bpm.error}/>
                        </div>
                        <div className="a-form-col">
                            <button className="bpm-opener-btn" type="button" onClick={toggleBpm}>
                                <span><FormattedMessage id="upload.bpmCalculator.button"/></span>
                            </button>
                        </div>
                    </div>
                </div>
                <h3 onClick={toggleAdvanced}
                    className={`upload-advanced-title ${showAdvanced ? 'active' : ''}`}>Advanced</h3>
                {showAdvanced && <div className="upload-advanced-group">
                    <div className="a-form-row">
                        <div className="a-form-col">
                            <MobileFormSelectField
                                options={keys} value={fields.key.value} onChange={onChangeKey}
                                label={translate({id: 'upload.form.key'})}/>
                        </div>
                        <div className="a-form-col">
                            <MobileFormSelectField
                                options={scales} value={fields.scale.value} onChange={onChangeScale}
                                label={translate({id: 'upload.form.scale'})}/>
                        </div>
                    </div>
                    <div className="a-form-row">
                        <div className="a-form-col">
                            <MobileFormSelectField
                                options={signatures} value={signature} onChange={onChangeSignature}
                                label={translate({id: 'upload.form.signature'})}/>
                        </div>
                        <div className="a-form-col">
                            <MobileFormSelectField
                                options={instruments} value={activeInstrument && activeInstrument.value} onChange={onSelectInstrument}
                                label={translate({id: 'upload.form.instrument'})}/>
                        </div>
                    </div>
                </div>}
                <div className="flexbox flex-end upload-form-button">
                    <BaseButton
                        id="upload-track-submit-button" className="upload-btn" disabled={isDisabledSubmit}
                        label={translate({id: 'general.save'})} type="submit" onClick={submit}/>
                </div>
                {
                    isUploading && <div className="loader-container"><CircularLoaderInline/></div>
                }
            </Fragment>
        );
    }
}

export default UploadFormMobile;
